// extracted by mini-css-extract-plugin
module.exports = {"editor":"styles_editor__wocol","suggestionsList":"styles_suggestionsList__9_CHH","suggestionSnippet":"styles_suggestionSnippet__YW5Mi"};